import React, { useEffect, useRef, useState } from "react";
import { Badge, Button, Card, Col, message, Row } from "antd";
import axios from "axios";
import {
  MdAutoAwesome,
  MdClear,
  MdMood,
  MdMoreVert,
  MdRefresh,
  MdSend,
} from "react-icons/md";
import ChatGPTGreeting from "./ChatGPTGreeting";
import ChatGPTSpeechBubble from "./ChatGPTSpeechBubble";
import { PaperClipOutlined } from "@ant-design/icons";
import "./Chat.scss";
import loadingDiscs from "./loading.svg";
import AxiosAPI from "../../../helpers/AxiosAPI";
import { useAppDataContext } from "../../../data/context/AppDataContext";
import {
    cleanupTempUpload,
    convertS3KeysToVisionMessages,
    createSupplierImageReference,
    fileToVisionMessages,
    INFORMAL_UPLOAD_LABEL,
    isPdfFile,
    isSupportedVisionFile,
    isImageFile,
    PdfQuoteEntry,
    resolveMessagesForApi,
    SUPPLIER_QUOTE_LABEL,
} from "./attachmentUtils";
interface DocumentListItemProps {
    children?: React.ReactNode;
    onChatGPTDrawerClose: any;
    selectedRFQ: any;
    isActive?: boolean;
}
interface GPTMessage {
    role: string;
    content: any;
    userTriggered?: boolean;
    displayMeta?: {
        fileName?: string;
        attachmentPreview?: string;
        isInformalUpload?: boolean;
    };
}
interface Supplier {
  name: string;
  primaryContact: any;
}
const ChatGPT2: React.FC<DocumentListItemProps> = ({ children, ...props }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const {
        userData,
    } = useAppDataContext();
    const { onChatGPTDrawerClose, selectedRFQ, isActive = true }: any = props;
    const fileInputRef = useRef<HTMLInputElement | null>(null);

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaWrapperRef = useRef<HTMLDivElement | null>(null);
  const [sendButtonColor, setSendButtonColor] = useState("#777777");

  const defaultMessages = [
    {
      role: "system",
      content:
        "You are an assistant for a Procurement Officer, or a Procurement Supervisor,for a SaaS procurement system called Supply Guard.",
    },
    {
      role: "system",
      content:
        "When requested for a table, do not add **bold** or *italic* formatting.",
    },
    {
      role: "system",
      content:
        "When providing a table with quotations, if there are other columns with terms and conditions, you can combine them as one column and name it note. For example, if there are columns for warranty, payment terms, and lead time, you can combine them into one column called notes.",
    },
    {
      role: "system",
      content: `Supply Guard is similar to Alibaba, in that it facilitates B2B sourcing.`,
    },
    {
      role: "system",
      content:
        "The particular area for you to focus on is the ‘Messenger’ page, which is similar to Alibaba Messenger.",
    },
    {
      role: "system",
      content: `if asked to summarize what the rfq is about, express the rfq details in a tabular format, and do not include quotes when describing the rfq. 
            Table format to be in 2 columns, first is the key field and the other for the value .
            You can however indicate how many quotes you have received, if any, thus far.`
        },
        {
            role: "system",
            content: "For the question: Get current status on this inquiry, only show RFQ details and do not list the submitted quotes."
        },
        {
            role: "system",
            content: `When asked to evaluate quotations or negotiate with suppliers and no official supplier quotations have been received via Messenger: Show the user the notified suppliers in tabular format (Supplier Name|Contact Email|Contact number) and let the user know that no official quotations have been received yet. Official quotations are labeled "Quotation from {supplier name}". Informal buyer uploads are labeled "Informal quote uploaded by buyer". Check all messages for image content before concluding no quotes exist.`
        },
        {
            role: "system",
            content: "Do not say 'no quotations have been received' without ensuring this is in fact the case. Distinguish between official supplier quotations submitted via Messenger and informal quote uploads from the buyer."
        },
        {
            role: "system",
            content: `When a quote image is received, especially an informal buyer upload, compare line items, category, description, and scope against the selected RFQ. If the quote is not relevant to this RFQ, clearly advise the buyer and explain why. If relevant, answer questions and perform evaluation.`
        },
        {
            role: "system",
            content: `If the buyer asks to add, submit, record, or incorporate an uploaded quote into the RFQ, politely decline. Explain that suppliers must be formally invited via Supply Zone Messenger so quotes are tracked and auditable. Offer to help draft an invite message or point them to the Invite Supplier action. Informal uploads are for reference and evaluation only.`
        },
        {
            role: "system",
            content: `For informal buyer uploads that are relevant, compare pricing and terms against official quotes already in the conversation. In comparison tables, label informal uploads as "unofficial / for reference only" and official Messenger quotes with the supplier name.`
        },
        //no quotes - show suppliers in table format
        {
            role: "system",
            content: `
                On the messenger page, there are a list of RFQ’s, or Request for Quotations.
                    This is the primary organizing concept.
                    a. There are two classes of organizations on Supply Guard: Buying 
                    Organizations, and Supplier Organizations. An organization can have 
                    multiple users on Supply Guard.
                    b. Buying Organizations can invite new suppliers, can create a list of 
                    pre-approved suppliers, or utilize Supply Guard’s extended network of 
                    vetted suppliers.
                    c. A Buying Organization seeks to streamline procurement activities by 
                    publishing RFQ’s which are then distributed to qualified Supplier 
                    Organizations for response.
                    d. A Supplier Organization seeks to receive genuine and high value 
                    RFQ’s from reputable Buying Organizations, and therefore pays for 
                    various tiers of membership on Supply Guard.
                    e. Supply Guard provides membership to a Supplier Organization to one 
                    or more categories, of which there are currently 13 categories.
                    f. An RFQ is created by a user
                    g. An RFQ has a creation date and an expiry date
                    h. An RFQ is considered active or open if the expiry date has not lapsed
                    i. An RFQ is considered expired or closed if the expiry date has lapsed.
                    j. An RFQ has a category, of which there are approximately 13, such as 
                    Automotive, Construction, Hardware, etc.
                    k. An RFQ has a description.
                    l. An RFQ has a unique number to identify it.
                    m. A supplier who is not currently a Supply Guard member, can be invited 
                    by a Buyer to join the system.
                    n. A supplier may be on a pre-approved list of the Buying Organization
                    o. A Buying Officer has various time consuming tasks that they must 
                    carry out daily, and you are to assist in improving their productivity, 
                    and over time, carry out the function autonomously.
                    i. A buying officer has to check the status of RFQs that are active,
                    and ensure that she responds to any messages from suppliers in
                    a timely manner.
                    ii. A buying officer has to ensure that a good number of quotes are
                    received, ideally between 3 to 9. If a supplier has not responded
                    within 24 hours, a follow up message should be sent to that 
                    supplier. Further, 24 hours before the expiry of an RFQ, a final 
                    reminder message should be sent to suppliers who have not yet 
                    sent quotes.
                    iii. A buying officer has to create a comparison table to compare 
                    prices of any given commodity between suppliers, taking into 
                    account price including VAT, price excluding VAT, payment 
                    terms, payment currency which is usually USD, warranty terms,
                    and lead time.
                    iv. When you do a comparison table, you want to compare ‘apples 
                    to apples’, so the commodity must be the same, currency must 
                    be the same, and so on. If there is a problem with a quote, 
                    which are normally PDF’s or Excel or Word documents, you 
                    should mention it to the Buying Officer, so corrections can be 
                    done if needed.
                    v. A buying officer has to then summarize the supplier responses, 
                    perform an analysis and make recommendations on which 
                    supplier(s) to choose.
                    vi. The buying officer may need to send further emails to negotiate
                    prices or terms with short-listed suppliers.
                    vii. All the RFQ information and attributes are organized within a 
                    relational database, which you should have access to.
                    viii. Overall you should seek to increase the productivity of the 
                    buying officer.
                    ix. Overall, you should seek to advance the interests of the buying 
                    organization.
                    x. You may be asked to create summaries for buying activity in a 
                    given time period, for a given category, for a given supplier, and
                    for a given buying officer.
                    xi. If you are not sure of anything, you can ask for clarification.
                `,
    },
  ];
  const [messages, setMessages] = useState<GPTMessage[]>(defaultMessages);

  const handleButtonClick = () => {
    if (
      fileInputRef &&
      fileInputRef.current !== null &&
      "click" in fileInputRef.current
    ) {
      fileInputRef.current.click();
    }
  };

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = event.target.files?.[0];
        if (file) {
            if (!isSupportedVisionFile(file.name)) {
                messageApi.open({
                    type: "error",
                    content:
                        "Unsupported file type. Please upload a PNG, JPG, WEBP, or PDF quotation.",
                    duration: 3,
                });
                event.target.value = "";
                return;
            }
            setAttachment(file);
            setAttachmentName(file.name);
        }
    };


  const messagesEndRef = useRef<HTMLDivElement | null>(null);

    const [chatMessage, setChatMessage] = useState("");
    const [attachmentName, setAttachmentName] = useState("");
    const [attachment, setAttachment] = useState<File | null>(null);
    const [isTyping, setIsTyping] = useState<boolean>(false);
    const [isConvertingAttachment, setIsConvertingAttachment] = useState<boolean>(false);
    const pendingTempS3KeyRef = useRef<string | undefined>(undefined);
    const gptRequestInFlightRef = useRef(false);
    const [messageRead, setMessageRead] = useState<boolean>(false);
    const [unreadMessages, setUnreadMessages] = useState<number>(0);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSendMessage = () => {
    sendMessage(chatMessage);
  };

  const handleChangedMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setChatMessage(e.target.value);
  };

    const handleTypingMessage = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!isConvertingAttachment) {
                sendMessage(chatMessage);
            }
        }
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height

      if (textareaWrapperRef.current) {
        textareaWrapperRef.current.style.height = "auto"; // Reset height
        textareaWrapperRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height
      }
    }

    setTimeout(() => {}, 500);
  };

    const onAutoResponseHandler = (text: string, event?: React.MouseEvent) => {
        sendMessage(text);
        if (event) {
            const clickedElement = event.currentTarget;
            clickedElement.classList.add('selected');
        }
    };

    const resetTextareaHeight = () => {
        try {
            if (textareaRef.current) {
                textareaRef.current.style.height = "52px";
                if (textareaWrapperRef.current) {
                    textareaWrapperRef.current.style.height = "52px";
                }
            }
        } catch (error) {
            setIsTyping(false);
        }
    };

    const sendMessage = async (chatMessage: string): Promise<void> => {
        const systemMessageIndex = messages.findIndex(
            (msg) =>
                msg.role === "system" &&
                msg.content.startsWith("The selected RFQ is")
        );
        if (systemMessageIndex === -1) {
            messageApi.open({
                type: "warning",
                content:
                    "Please wait a moment for the RFQ details to load before sending a message.",
                duration: 2,
            });
            return;
        }

        const trimmedMessage = chatMessage.trim();
        const hasText = trimmedMessage !== "";
        const hasAttachment = attachment !== null;

        if (!hasText && !hasAttachment) {
            return;
        }

        if (hasAttachment && attachment && !isSupportedVisionFile(attachment.name)) {
            messageApi.open({
                type: "error",
                content:
                    "Unsupported file type. Please upload a PNG, JPG, WEBP, or PDF quotation.",
                duration: 3,
            });
            return;
        }

        const newMessages: GPTMessage[] = [];

        if (hasAttachment && attachment) {
            setIsConvertingAttachment(true);
            if (isPdfFile(attachment.name)) {
                messageApi.open({
                    type: "loading",
                    content: "Converting PDF…",
                    duration: 0,
                });
            }

            try {
                const label = INFORMAL_UPLOAD_LABEL(attachment.name);
                const { messages: visionMessages, tempS3Key } =
                    await fileToVisionMessages(
                        attachment,
                        label,
                        hasText ? trimmedMessage : undefined
                    );

                pendingTempS3KeyRef.current = tempS3Key;

                visionMessages.forEach((msg, index) => {
                    newMessages.push({
                        ...msg,
                        userTriggered: index === visionMessages.length - 1,
                    });
                });

                if (!hasText && visionMessages.length > 0) {
                    const last = newMessages[newMessages.length - 1];
                    last.userTriggered = true;
                }
            } catch (error) {
                messageApi.destroy();
                messageApi.open({
                    type: "error",
                    content:
                        "Could not process the attachment. Please try again or upload an image instead.",
                    duration: 3,
                });
                setIsConvertingAttachment(false);
                return;
            } finally {
                messageApi.destroy();
                setIsConvertingAttachment(false);
            }
        } else if (hasText) {
            newMessages.push({
                role: "user",
                content: trimmedMessage,
                userTriggered: true,
            });
        }

        if (newMessages.length === 0) {
            return;
        }

        setMessages([...messages, ...newMessages]);
        setChatMessage("");
        setAttachmentName("");
        setAttachment(null);
        setIsTyping(false);
        resetTextareaHeight();

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    useEffect(() => {
        const handleFocus = () => {
            setMessageRead(true);
            setUnreadMessages(0);
        };

        const handleScroll = () => {
            setMessageRead(true);
            setUnreadMessages(0);
        };

        window.addEventListener("focus", handleFocus);
        window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

    React.useEffect(() => {
        const lastMessage = messages[messages.length - 1];
        if (!lastMessage || lastMessage.role !== "user") {
            return;
        }

        if (Array.isArray(lastMessage.content) && !lastMessage.userTriggered) {
            return;
        }

        if (gptRequestInFlightRef.current) {
            return;
        }

        gptRequestInFlightRef.current = true;
        let cancelled = false;

        const runCompletion = async () => {
            const key ='c2stcHJvai0yajZsaTQwaWhXaG9xVlg5QUw3c0t4Nk1OTndibHlqSVBXeWZxU3VVZFQ4WHZJZGxYLVlSNjJpbUhlVmhDbEYyUGwxUFhua01KZlQzQmxia0ZKNHJHNE5HUWJ6ZFF3eWs3VDZ0UjVYdDdZeFBHMnEtd0xJN2JVYkFYckJKUFh2cUxTQkF6cHJMVEFsdERJMVRzOE1FQXBscXhjVUE=';
            const keyToUse = atob(key);
            setIsTyping(true);
            scrollToBottom();

            try {
                const apiMessages = await resolveMessagesForApi(messages);
                if (cancelled) {
                    return;
                }

                const config = {
                    method: 'POST',
                    url: 'https://api.openai.com/v1/chat/completions',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${keyToUse}`,
                        'OpenAI-Organization': 'org-RGzukEAhJUMRdCtmrCCeI4Df'
                    },
                    data: JSON.stringify({
                        model: 'gpt-4.1-mini',
                        messages: apiMessages,
                        max_tokens: 16383,
                        temperature: 0.60,
                        response_format: { type: 'text' }
                    }),
                };

                const res = await axios(config);
                if (cancelled) {
                    return;
                }

                const assistantContent = res.data?.choices?.[0]?.message?.content
                    || "I don't have enough information on that topic yet, but I'd be happy to help with related questions or explore this further with you!";

                setMessages((prev) => [
                    ...prev,
                    { role: 'assistant', content: assistantContent },
                ]);
                cleanupTempUpload(pendingTempS3KeyRef.current);
                pendingTempS3KeyRef.current = undefined;
            } catch {
                if (!cancelled) {
                    messageApi.open({
                        type: "error",
                        content: "SimplexAI could not respond. Please try again.",
                        duration: 3,
                    });
                }
            } finally {
                if (!cancelled) {
                    setIsTyping(false);
                }
                gptRequestInFlightRef.current = false;
            }
        };

        runCompletion();

        return () => {
            cancelled = true;
            gptRequestInFlightRef.current = false;
        };
    }, [messages]);

    React.useEffect(() => {
        if (!isActive || !selectedRFQ?.id) {
            return;
        }

        let cancelled = false;

        const loadRfqContext = async () => {
            try {
                const res = await AxiosAPI.getBuyerSellerRFQResponses(selectedRFQ.id);
                const listData = res.data;

                const attachments: any[] = [];
                const suppliersWhoResponded: Supplier[] = [];
                listData.forEach((supplierResponse: any) => {
                    suppliersWhoResponded.push({
                        name: supplierResponse.supplierCompanyName,
                        primaryContact: supplierResponse.primaryContact,
                    });
                    supplierResponse.messageThread.thread.forEach((chat: any) => {
                        if (chat.s3Key && chat.s3Key.length > 4) {
                            attachments.push({
                                name: chat.attachmentName,
                                type: chat.attachmentType,
                                s3Key: chat.s3Key,
                                modified: chat.date.split("T")[0],
                                senderCompany: chat.senderCompany,
                            });
                        }
                    });
                });

                const newMessages: GPTMessage[] = [
                    {
                        role: "system",
                        content: "The selected RFQ is: " + JSON.stringify(selectedRFQ),
                    },
                ];

                const quoteVisionMessages: GPTMessage[] = [];
                const pdfEntries: PdfQuoteEntry[] = [];

                for (const attachment of attachments) {
                    const label = SUPPLIER_QUOTE_LABEL(attachment.senderCompany);
                    if (isImageFile(attachment.name)) {
                        quoteVisionMessages.push(
                            createSupplierImageReference(
                                attachment.s3Key,
                                label,
                                attachment.name
                            )
                        );
                    } else if (isPdfFile(attachment.name)) {
                        pdfEntries.push({ s3Key: attachment.s3Key, label });
                    }
                }

                if (pdfEntries.length > 0) {
                    try {
                        const pdfMessages = await convertS3KeysToVisionMessages(pdfEntries);
                        quoteVisionMessages.push(...pdfMessages);
                    } catch {
                        if (!cancelled) {
                            messageApi.open({
                                type: "warning",
                                content: "Some PDF quotations could not be converted for analysis.",
                                duration: 3,
                            });
                        }
                    }
                }

                const sellersRes = await AxiosAPI.getBuyerSellers();
                let notifiedSuppliers = sellersRes.data.map(
                    ({ name, primaryContact }: Supplier) => ({
                        name,
                        primaryContact,
                    })
                );
                notifiedSuppliers = [...notifiedSuppliers, ...suppliersWhoResponded];

                newMessages.push({
                    role: "system",
                    content:
                        "The following suppliers have been notified about the RFQ: " +
                        JSON.stringify(notifiedSuppliers),
                });

                if (userData.person && userData.person.firstName) {
                    newMessages.push({
                        role: "system",
                        content: `The current user is: ${userData.person.firstName} ${userData.person.lastName}`,
                    });
                }

                if (!cancelled) {
                    setMessages([
                        ...defaultMessages,
                        ...newMessages,
                        ...quoteVisionMessages,
                    ]);
                }
            } catch {
                if (!cancelled) {
                    messageApi.open({
                        type: "warning",
                        content: "Failed to load RFQ details. Please try again.",
                        duration: 3,
                    });
                }
            }
        };

        loadRfqContext();

        return () => {
            cancelled = true;
        };
    }, [selectedRFQ?.id, isActive]);

    React.useEffect(() => {
        const canSend =
            chatMessage.trim() !== "" || attachment !== null;
        setSendButtonColor(canSend ? "#552278" : "#777777");
    }, [chatMessage, attachment]);

  return (
    <>
      {contextHolder}
      <div className="sai-chat-wrapper">
        <div className="sai-chat-header">
          <Row wrap={false} style={{ margin: "8px" }} gutter={8}>
            <Col flex="none">
              {messageRead ? (
                <div className="sai-avatar">
                  <MdAutoAwesome size={18} />
                </div>
              ) : (
                <Badge dot>
                  <div data-unread={`${unreadMessages}`} className="sai-avatar">
                    <MdAutoAwesome size={18} />
                  </div>
                </Badge>
              )}
            </Col>
            <Col flex="auto">
              <span className="sai-logo-text">
                SimplexAI
                <span
                  className="badge"
                  style={{
                    backgroundColor: "#542277",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "5px",
                    fontSize: "12px",
                    marginLeft: "15px",
                  }}
                >
                  {selectedRFQ.id}
                </span>
              </span>
            </Col>

                        <Col flex="none">
                            <Button
                                type="text"
                                size="large"
                                icon={<MdRefresh size={32} color="#999" />}
                                onClick={() => {
                                    setMessages([]);
                                }}
                            />
                        </Col>
                        <Col flex="none">
                            <Button
                                type="text"
                                size="large"
                                icon={<MdMoreVert size={32} color="#999" />}
                            />
                        </Col>
                        <Col flex="none">
                            <Button
                                type="text"
                                size="large"
                                icon={<MdClear size={32} color="#999" />}
                                onClick={() => {
                                    onChatGPTDrawerClose()
                                }}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="sai-chat-body">
                    <div className="scroller">
                        <div className="imessage">
                            <ChatGPTGreeting onAutoResponse={onAutoResponseHandler} />
                            {messages
                                .filter((message: GPTMessage) => {
                                    if (message.role === "system") {
                                        return false;
                                    }
                                    if (message.role === "assistant") {
                                        return true;
                                    }
                                    if (message.role === "user") {
                                        if (typeof message.content === "string") {
                                            return true;
                                        }
                                        return Boolean(
                                            message.userTriggered ||
                                            message.displayMeta?.isInformalUpload
                                        );
                                    }
                                    return false;
                                })
                                .map((message: GPTMessage, messageIndex: number) => (
                                    <ChatGPTSpeechBubble
                                        key={messageIndex}
                                        content={message.content}
                                        displayMeta={message.displayMeta}
                                        isLocal={message.role == 'user'}
                                        onAutoResponse={onAutoResponseHandler}
                                    />
                                ))}
                        </div>
                        {isTyping && (
                            <img
                                style={{ width: 48, opacity: 0.4, margin: 24 }}
                                src={loadingDiscs}
                                alt="Loading"
                            />
                        )}
                        {isConvertingAttachment && (
                            <div style={{ margin: 24, color: "#777" }}>
                                Converting PDF…
                            </div>
                        )}
                        <div ref={messagesEndRef} style={{ marginBottom: 50 }} />
                    </div>

          <Card
            ref={textareaWrapperRef}
            className={`sai-prompt-wrapper`}
            bordered={false}
          >
            <Row wrap={false} style={{ margin: "3px" }} gutter={8}>
              <Col flex="none">
                <Button
                  shape="circle"
                  type="text"
                  size="large"
                  icon={<MdMood size={32} color="#777777" />}
                />
              </Col>
              <Col flex="auto">
                <textarea
                  ref={textareaRef}
                  className="sai-input"
                  placeholder="Type your message here..."
                  value={chatMessage}
                  onChange={handleChangedMessage}
                  onKeyUp={handleTypingMessage}
                />
              </Col>

                            <Col flex="none">
                                <Button
                                    shape="circle"
                                    type="text"
                                    size="large"
                                    icon={
                                        <PaperClipOutlined
                                            style={{ fontSize: "26px", color: "#777777" }}
                                            color="#777777"
                                        />
                                    }
                                    onClick={handleButtonClick}
                                />
                            </Col>
                            <Col flex="none">
                                <Button
                                    onClick={handleSendMessage}
                                    disabled={isConvertingAttachment}
                                    shape="circle"
                                    type="text"
                                    size="large"
                                    style={{ color: sendButtonColor }}
                                    icon={<MdSend size={26} />}
                                />
                            </Col>
                        </Row>
                    </Card>
                    <input
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        type="file"
                        accept=".png,.jpg,.jpeg,.webp,.pdf"
                        name="attachment"
                        id="collaboration-attachment"
                    />
                    {attachment === null ? (
                        <span className="sai-disclaimer">
                            Upload a quotation (image or PDF) for price evaluation. This does not submit the quote to the RFQ.{" "}
                            <a href="#">Privacy Statement</a>
                        </span>
                    ) : (
                        <span className="sai-disclaimer">
                            <PaperClipOutlined />
                            Selected File: <strong>{attachmentName}</strong>
                        </span>
                    )}
                </div>
            </div>
        </>
    )
}
export { ChatGPT2 };
